// extracted by mini-css-extract-plugin
export var avatar = "avatar__lzyvD";
export var congratsImage = "congrats-image__saFQ6";
export var greetingMessage = "greeting-message__TRiT3";
export var confirmationMessage = "confirmation-message__s3mRd";
export var message = "message__AoecG";